(function () {
    'use strict';

    angular
        .module('core', [
            'ngSanitize',

            'ui.router',
            'smart-table',
            '19degrees.ngSweetAlert2',
            'angularValidator',
            'ngMask',
            'ui.select',
            'ngNotify',
            'ui.bootstrap.datetimepicker',
            'flow',
            'lodash',

            'core.configs',
            'core.constants',
            'core.components',
            'core.directives',
            'core.filters',
            'core.interceptors',
            'core.routes',
            'core.helpers',
            'core.services',

            'franchisee',
            'franchiser'
        ])
        .run(run);

    /** @ngInject */
    function run($trace, $transitions, $rootScope, $window, AppCycleHelper) {
        $trace.enable(1, 5);

        AppCycleHelper.handleOnRun();

        $rootScope.$on('$locationChangeStart', event => {
            AppCycleHelper.handleLocationChangeStart(event);
        });

        $transitions.onEnter({}, $transition => {
            return AppCycleHelper.handleStateChangeStart($transition);
        });

        $transitions.onSuccess({}, $transition => {
            $rootScope.pageTitle = `${$transition.to().title} - ${$rootScope.toolName}`;

            AppCycleHelper.handleStateChangeSuccess();
        });

        $transitions.onError({}, ($transition, error) => {
            AppCycleHelper.handleStateChangeError(error);
        });

        $window.onload = () => {
            AppCycleHelper.handleViewContentLoaded();
        }

        $rootScope.$on('$viewContentLoaded', AppCycleHelper.handleViewContentLoaded);
    }
})();